export default __webpack_public_path__ + "static/media/home-restaurant-img-04.39e3e943.jpg";